import React from 'react';

function Image({
  src,
  alt = "Image Name",
  className = "",
  ...props
}) {

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={(e) => {
        e.target.src = "/assets/images/RBS_LOGO_23_2_-1768354637228.png"
      }}
      {...props}
    />
  );
}

export default Image;
